import { Box } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import WhatwedoBg3 from "../../assets/images/whatwedobanner3.webp";

const WhatwedoBglanding = () => {
  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: { xs: "6rem", sm: "5rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box sx={{}}>
        <LazyLoadImage
          src={WhatwedoBg3}
          effect="blur"
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default WhatwedoBglanding;
